module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_flacidez.6531c865.jpg";